// extracted by mini-css-extract-plugin
module.exports = {"page":"legalPage_page__6Jws4","hero":"legalPage_hero__nofO_","heading":"legalPage_heading__Bjvto","body":"legalPage_body__uTaBR"};